<template>
  <div class="region-map">
    <div class="map">
      <div id="region_map" class="map-echarts" ref="regionMapRef"></div>
    </div>
    <div class="region-bottom">
      <div class="region-number-list">
        <div class="top-list">
          <div class="top-item one">
            <img :src="require('@/assets/images/bg-item3.png')" alt="">
          </div>
          <div class="top-item two">
            <img :src="require('@/assets/images/bg-item2.png')" alt="">
            <div class="number-box">
              <div class="number">8692</div>
              <div class="name">在线课程</div>
            </div>
          </div>
          <div class="top-item three">
            <img :src="require('@/assets/images/bg-item2.png')" alt="">
            <div class="number-box">
              <div class="number">11.8<span style="font-family:tahoma">W</span></div>
              <div class="name">资源建设</div>
            </div>
          </div>
          <div class="top-item four">
            <img :src="require('@/assets/images/bg-item2.png')" alt="">
            <div class="number-box">
              <div class="number">264</div>
              <div class="name">活动评审</div>
            </div>
          </div>
          <div class="top-item five">
            <img :src="require('@/assets/images/bg-item3.png')" alt="">
          </div>
          <div class="top-item six">
            <img :src="require('@/assets/images/bg-item1.png')" alt="">
          </div>
        </div>
        <div class="bottom-list">
          <div class="bottom-item one">
            <img :src="require('@/assets/images/bg-item1.png')" alt="">
          </div>
          <div class="bottom-item two">
            <img :src="require('@/assets/images/bg-item2.png')" alt="">
            <div class="number-box">
              <div class="number">125</div>
              <div class="name">集体备课</div>
            </div>
          </div>
          <div class="bottom-item three">
            <img :src="require('@/assets/images/bg-item2.png')" alt="">
            <div class="number-box">
              <div class="number">226</div>
              <div class="name">考试</div>
            </div>
          </div>
          <div class="bottom-item four">
            <img :src="require('@/assets/images/bg-item2.png')" alt="">
            <div class="number-box">
              <div class="number">52</div>
              <div class="name">名师工作室</div>
            </div>
          </div>
          <div class="bottom-item five">
            <img :src="require('@/assets/images/bg-item2.png')" alt="">
            <div class="number-box">
              <div class="number">154</div>
              <div class="name">听评课</div>
            </div>
          </div>
          <div class="bottom-item six">
            <img :src="require('@/assets/images/bg-item2.png')" alt="">
            <div class="number-box">
              <div class="number">213</div>
              <div class="name">论坛研讨</div>
            </div>
          </div>
          <div class="bottom-item seven">
            <img :src="require('@/assets/images/bg-item3.png')" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getRegionSchoolInfomation,
  getNextRegionSchoolInfomation,
  queryBaseRegionCoordinateByRegionCode,
} from "@/service/api";
const cityMap = () => import("@/views/areaschooldataboard/modules/CityMap");
export default {
  name: 'region-map',
  components: {
      cityMap
  },
  data() {
    return {
      areaParams: {
          provinceCode: '安徽省',
          provinceName: '340000',
          districtCode: '340104',
          districtName: '蜀山区',
          cityCode: '340100',
          cityName: '合肥市'
      },
      schoolNum:0,
      classNum:0,
      studentNum:0,
      teacherNum:0,
      geoCoordMap:{},
      regionId:"5ee5b923177a45aeb8133caaed684003",
      typeInfo:null
    }
  },
  methods: {
    async getRegionSchoolInformation(){
      let _this = this;
      let params = {
        provinceCode: _this.areaParams.provinceCode,
        cityCode: _this.areaParams.cityCode,
        districtCode: _this.areaParams.districtCode,
        regionId:_this.regionId
      };
      let res = await getRegionSchoolInfomation(params);
      _this.schoolNum = res[0].schoolNum;
      _this.classNum = res[0].classNum;
      _this.studentNum = res[0].stuNum;
      _this.teacherNum = res[0].teaNum;
    },
    /**
     * 根据区域编码获取地理位置数据
     */
     async getBaseRegionCoordinateByRegionCode(data) {
      let _this = this;
      let params = {
        regionCode: data,
      };
      let res = await queryBaseRegionCoordinateByRegionCode(params);
      return JSON.parse(res.coordinateCode);
    },
    /**
     * 初始化区域地图
     */
     initDistrictsMap(data) {
      let _this = this;
      _this.districtData = data;
      this.$echarts.registerMap(_this.areaName, _this.districtData); //注册
      //获取市级下区域的经纬度
      let mapFeatures = this.$echarts.getMap(_this.areaName).geoJson.features;
      mapFeatures.forEach(function (v) {
        // 地区名称
        let name = v.properties.name;
        // 地区经纬度
        _this.geoCoordMap[name] = v.properties.centroid;
      });
      _this.initMap(_this.areaName);
    },
        /**
     * 渲染地图
     */
     initMap(provinceName) {
      let _this = this;
      //配置样式
      var optionMap = {
        geo: {
          map: provinceName,
          zoom: 1.1,
          roam: false,
          top: "5%",
          label: {
            normal: {
              show: false,
              textStyle: {
                color: "#fff",
              },
            },
            emphasis: {
              show: false,
              color: "#fff",
            },
          },
          itemStyle: {
            normal: {
              areaColor: "#24CFF4",
              borderColor: "#53D9FF",
              borderWidth: 1.3,
              shadowBlur: 15,
              shadowColor: "rgb(58,115,192)",
              shadowOffsetX: 7,
              shadowOffsetY: 6,
            },
            emphasis: {
              areaColor: "#8dd7fc",
              borderWidth: 1.6,
              shadowBlur: 25,
            },
          },
        },
        series: [
          {
            type: "effectScatter",
            coordinateSystem: "geo",
            geoIndex: 0,
            data: _this.convertData(_this.data),
            symbolSize: 12,
            showEffectOn: "render",
            rippleEffect: {
              brushType: "stroke",
            },
            animation: true,
            label: {
              normal: {
                formatter: "{b}",
                position: "top",
                show: true,
                textStyle: {
                  color: "#fff",
                },
              },
            },
            itemStyle: {
              normal: {
                color: "#f4e925",
                shadowBlur: 10,
                shadowColor: "#333",
              },
            },
            zlevel: 1,
          },
          {
            name: "categoryChina",
            type: "map",
            geoIndex: 0,
            data: _this.data,
          },
        ],
      };
      let winHeight = window.innerHeight;
      if (winHeight < 900) {
        winHeight = 938;
      }
      let dom = document.getElementById("region_map");
      //得到echarts的实例对象
      _this.map = _this.$echarts.init(dom);
      _this.map.setOption(optionMap);
      //点击弹出区地图
      _this.map.on("click", function (params) {
        if(params.seriesType == "effectScatter"&&params.name == '高新智慧学校'){
          window.open("https://preschool.iclass30.com/schoolresource","_blank")
        }else{
          return 
        }
      });
    },
    /**
     * 各地区经纬度，数值data
     */
     convertData(data) {
      let _this = this;
      var res = [];
      res.push({
        code: "340104",
        name: "高新智慧学校",
        value: [117.056602, 31.871074, 0]
      })
      res.push({
        code: "340104",
        name: "新华小学",
        value:[117.026139,31.992767,0]
      })
      res.push({
        code: "340104",
        name: "第七中学",
        value: [117.002445, 31.862462, 0]
      })
      res.push({
        code: "340104",
        name: "实验第二中学",
        value:[117.2064856,31.8535432,0]
      })
      res.push({
        code: "340104",
        name: "高新区实验中学",
        value:[117.1824856,31.8305432,0]
      })
      res.push({
        code: "340104",
        name: "实验中学",
        value:[117.0035856,31.8305432,0]
      })
      res.push({
        code: "340104",
        name: "华维文澜中学",
        value:[117.0066128,31.921074,0]
      })
      res.push({
        code: "340104",
        name: "北京路中学",
        value:[117.0166028,31.951274,0]
      })
      res.push({
    code: "340104",
    name: "明德小学",
    value: [117.227239, 31.820587,0]
  })
  res.push({
    code: "340104",
    name: "高新第四中学",
    value: [117.13897 , 31.852044,0]
  })
  res.push({
    code: "340104",
    name: "振新小学",
    value: [117.130074, 31.835302,0]
  })
  res.push({
    code: "340104",
    name: "琥珀中学",
    value: [116.900092, 31.957609,0]
  })
  res.push({
    code: "340104",
    name: "兴圆中学",
    value: [117.241800, 31.761128,0]
  })
      return res;
    },
        /**
     * 通过区域code获取下级区域数据
     */
     async getNextRegionSchoolInformation() {
      let _this = this;
      let params = {
        provinceCode: _this.areaParams.provinceCode,
        cityCode: _this.areaParams.cityCode,
        // districtCode: _this.areaParams.districtCode,
        regionId:_this.regionId
      };
      let res = await getNextRegionSchoolInfomation(params);
      _this.data = _this.getAreaMapData(res);
      //根据区域编码获取地理位置数据
      let data = await _this.getBaseRegionCoordinateByRegionCode(
        _this.areaParams.districtCode
      );
      _this.initDistrictsMap(data);
    },
        /**
     * 获取地图数据
     */
     getAreaMapData(list) {
      let data = [];
      for (let i = 0; i < list.length; i++) {
        let areaObj = {};
        areaObj.name =
          this.type == "province" ? list[i].cityName : list[i].districtName;
        areaObj.code =
          this.type == "province" ? list[i].cityCode : list[i].districtCode;
        areaObj.value = list[i].schoolNum;
        areaObj.districtDataList = [
          {
            name: "学校总数",
            value: list[i].schoolNum,
          },
          {
            name: "班级总数",
            value: list[i].classNum,
          },
          {
            name: "教师总数",
            value: list[i].teaNum,
          },
          {
            name: "学生总数",
            value: list[i].stuNum,
          },
        ];
        data.push(areaObj);
      }
      return data;
    },
    init(){
        let boxdom = document.getElementById('box');
        if( !boxdom ){
            return
        }
        let aDiv = boxdom.childNodes
        for (var i = 0; i < aDiv.length; i++) {
        aDiv[i].style.background =
            "url(img/" + (i + 1) + ".jpg) center/cover";
        aDiv[i].style.transform =
            "rotateY(" + i * 45 + "deg) translate3d(0,0,350px)";
        aDiv[i].style.transition =
            "transform 1s " + (aDiv.length - i) * 0.2 + "s";
        }
        setTimeout(()=>{
            this.timer = setInterval(this.dynamicScroll, 30);
        },200)
    },
    dynamicScroll(){
        let boxdom = document.getElementById('box');
        let transform = boxdom.style.transform
        let i = 0;
        try{
            let startIndex = transform.indexOf("rotateY(") + 8; 
            let endIndex = transform.indexOf(")", startIndex); 
            let value = transform.substring(startIndex, endIndex);
            i = value.substring(0,value.length - 3)
            if(i){
                i = Number(i)
            }
        }catch{}
        let index = i+1
        boxdom.style.transform = `rotateX(-17deg) rotateY(${index}deg)`
    }
  },
  async mounted(){
    let _this = this;
    //通过区域code获取区域数据
    _this.getRegionSchoolInformation();
    // //通过区域code获取下级区域数据
    _this.getNextRegionSchoolInformation();
    this.init();
  }
}
</script>
<style lang='scss' scoped>
.region-map{
    width: 100%;
    height: 825px;
    // padding: 0 15px;
    // background: rgba(6,17,52,0.8);
    border: 1px solid #053882;
    position: relative;
    margin-bottom: 20px;
    .map{
      width: 100%;
      height: 65%;
      overflow: hidden;
      .map-echarts{
        width: 100%;
        height: 100%;
        // transform: rotate(-5deg);
      }
    }
    .region-bottom{
      margin-top: -5%;
      height: 35%;
      width: 100%;
      .region-number-list{
        .top-list{
          display: inline-flex;
          .top-item{
            position: relative;
            img{
              display: block;
              width: 100%;
              height: 100%;
            }
            
            .number-box{
              display: flex;
              align-items: center;
              flex-direction: column;
              width: 100%;
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
              .number{
                font-family: MaravaleExpanded;
                font-weight: 400;
                color: #38FFF3;
                @font-face {
                  font-family: MaravaleExpanded;
                  src: url('../../../assets/fonts/digifaw.ttf'); //字体路径
                }
              }
              .name{
                margin-top: 10px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #7ABFDB;
              }
            }
          }
          .one{
            width: 70px;
            height: 80px;
            margin-right: 25px;
            margin-top: 50px;
            // margin-left: 65px;
          }
          .two{
            width: 110px;
            height: 140px;
            margin-right: 15px;
            margin-top: 15px;
            .number-box{
              .number{
                font-size: 28px;
              }
              .name{
                font-size: 16px;
              }
            }
          }
          .three{
            width: 135px;
            height: 175px;
            margin-right: 15px;
            .number-box{
              .number{
                font-size: 28px;
              }
              .name{
                font-size: 18px;
              }
            }
          }
          .four{
            width: 120px;
            height: 155px;
            margin-right: 30px;
            margin-top: 15px;
            .number-box{
              .number{
                font-size: 28px;
              }
              .name{
                font-size: 16px;
              }
            }
          }
          .five{
            width: 80px;
            height: 90px;
            margin-right: 15px;
            margin-top: 60px;
          }
          .six{
            width: 60px;
            height: 80px;
            margin-top: 62px;
          }
        }
        .bottom-list{
          display: inline-flex;
          margin-top: -30px;
          .bottom-item{
            position: relative;
            img{
              display: block;
              width: 100%;
              height: 100%;
            }
            .number-box{
              display: flex;
              align-items: center;
              flex-direction: column;
              width: 100%;
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
              .number{
                font-family: MaravaleExpanded;
                font-weight: 400;
                color: #38FFF3;
                @font-face {
                  font-family: MaravaleExpanded;
                  src: url('../../../assets/fonts/digifaw.ttf'); //字体路径
                }
              }
              .name{
                margin-top: 10px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #7ABFDB;
              }
            }
          }
          .one{
            // margin-left: 20px;
            width: 60px;
            height: 80px;
            margin-top: -10px;
            margin-right: 15px;
          }
          .two{
            width: 115px;
            height: 145px;
            margin-right: 15px;
            margin-top: 5px;
            .number-box{
              .number{
                font-size: 28px;
              }
              .name{
                font-size: 16px;
              }
            }
          }
          .three{
            width: 120px;
            height: 145px;
            margin-right: 15px;
            margin-top: 3px;
            .number-box{
              .number{
                font-size: 28px;
              }
              .name{
                font-size: 16px;
              }
            }
          }
          .four{
            width: 135px;
            height: 175px;
            margin-right: 15px;
            .number-box{
              .number{
                font-size: 28px;
              }
              .name{
                font-size: 16px;
              }
            }
          }
          .five{
            width: 120px;
            height: 155px;
            margin-right: 15px;
            .number-box{
              .number{
                font-size: 28px;
              }
              .name{
                font-size: 16px;
              }
            }
          }
          .six{
            width: 110px;
            height: 140px;
            margin-right: 5px;
            .number-box{
              .number{
                font-size: 28px;
              }
              .name{
                font-size: 16px;
              }
            }
          }
          .seven{
            width: 50px;
            height: 55px;
          }
        }
      }
    }
  }
</style>